<template>
  <nav>
    <v-app-bar app flat dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="headline">
        <span class="text-uppercase">VISION</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="signOut" depressed color="transparent">
        Abmelden
        <v-icon right>mdi-exit-to-app</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer app v-model="drawer" class="orange accent-3">
         <v-layout fill-height column >
      <v-list>
        <v-list-item
          v-for="link in links"
          :key="link.text"
          router
          :to="link.route"
          active-class="black--text"
        >
          <v-list-item-action>
            <v-icon>{{link.icon}}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{link.text}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
     <v-layout align-end justify-start>
        <v-flex lg3 class="ml-2 mb-2">
          <v-avatar color="orange accent-2">
            <v-icon class="white--text">mdi-account</v-icon>
          </v-avatar>
        </v-flex>
          <v-flex lg9 class="mb-1">
          <p v-if="user" class="white--text subheading">{{user.email}}</p>
        </v-flex>
        </v-layout>
      </v-layout>
    </v-navigation-drawer>
  </nav>
</template>

<style>
  nav {
    padding-bottom:0!important;
  }
  .v-content {
    padding-bottom:0!important;
  }
</style>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";
export default {
   mounted() {
    this.setupFirebase();
  },
   methods: {
    setupFirebase() {
      var self = this;
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          // User is signed in.
          console.log("signed in");
          this.loggedIn = true;
          self.user = user;
          
        } else {
          // No user is signed in.
          this.loggedIn = false;
          console.log("signed out", this.loggedIn);
        }
      });
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({ name: "login" });
        });
    }
  },
  data() {
    return {
      user: null,
      drawer: false,
      loggedIn: false,
      links: [
        { icon: "mdi-checkbook", text: "Coupons", route: "/coupon" },
       
      ]
    };
  }
};
</script>
